<template>
    <v-ons-page>
        <div class="content-inner content-inner-fill">
            <v-ons-list class="list-fill" v-if="outlet">
                <div class="main-header main-header-spaced">Location</div>
                <v-ons-list-item modifier="chevron" tappable v-on:click="app.openMap(outlet.address_lines)">
                    <div class="center">Address</div>
                    <div class="right">{{ outlet.address_lines.join(', ') }}</div>
                </v-ons-list-item>
                <template v-show="outlet.has_coordinates">
                    <div class="main-header main-header-spaced">Map</div>
                    <v-ons-list-item class="list-item-fill">
                        <div ref="map" class="list-content-fill"></div>
                    </v-ons-list-item>
                </template>
            </v-ons-list>
        </div>
    </v-ons-page>
</template>

<script>
    import { mapGetters, mapMutations } from 'vuex'
    import GoogleMapsLoader from 'google-maps'

    import { default as WhenOutletLoadedMixin } from '../../../mixins/whenoutletloaded'

    export default {

        mixins: [WhenOutletLoadedMixin],

        mounted(){

        },

        data(){
            return {
                app: this.$root.$data.app,
            }
        },

        methods: {

            whenOutletLoaded(){

                if (this.outlet.has_coordinates) {

                    const el = this.$refs.map

                    GoogleMapsLoader.KEY = env.google_maps_key
                    GoogleMapsLoader.VERSION = env.google_maps_version
                    GoogleMapsLoader.LIBRARIES = ['visualization']

                    GoogleMapsLoader.load((google) => {

                        // Init map
                        const map = new google.maps.Map(el, {
                            center: {
                                lat: this.outlet.latitude,
                                lng: this.outlet.longitude
                            },
                            zoom: 15
                        })

                        const outlet_coordinates = new google.maps.LatLng(
                            this.outlet.latitude,
                            this.outlet.longitude
                        )

                        const marker = new google.maps.Marker({
                            position: outlet_coordinates,
                            map: map,
                        })
                    })
                }
            },
        },

        computed: {
            ...mapGetters([
                'outlet',
            ]),
        },

    }
</script>

<style scoped>

</style>


// WEBPACK FOOTER //
// src/js/components/outlets/tabs/location.vue